import request from '@service/request';
import config from '@config';
import { getAuthOptions } from '@service/utils.js';

const path = `${config.apiURL}/bracket-view`;

// Devuelve { real, original, effective }, cada uno keyed-by-mid con forma
// compartida (teams/scores/winner/assertions + meta). El server resuelve todo;
// el cliente no propaga nada.
export const fetchBracketView = (token, userId) =>
  request.get(path, { params: { userId }, ...getAuthOptions(token) });
